// @ts-nocheck
import AIGenerateButton from '../../../AIGenerateButton/AIGenerateButton';
import Editor from '../../../Editor/Editor';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MuiTelInput } from 'mui-tel-input';
import {
  XGInput,
  XGDatePicker,
  XGTimePicker,
  XGSelect,
  XGAttachments,
  XGImages
} from 'xg-cl';
import XGTextarea from '../../../ProseTextarea/ProseTextarea';
import {
  generateServiceTypeFieldId,
  generateServiceTypeFieldKey,
  generateCheckBoxOptions,
  getValueFromServiceField
} from '../../../../utils/serviceTypes/serviceTypes';
import CheckBoxGroup from '../../../CheckBoxGroup/CheckBoxGroup';
import { Box, Typography, FormHelperText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  fileType,
  pathReference,
  maxImageSize,
  maxFileSize,
  maxImages,
  maxAttachments,
  STOCK_PHOTO_MAX_IMAGE_SIZE
} from '../../../../constants/files';
import { getTripDescription } from '../../../../services/ai/ai';
import { bytesToMiB } from '../../../../utils/fileHelper';
import { useState } from 'react';
import {
  utcTimeISO,
  convertInputDate,
  utcStringToLocalDate
} from '../../../../utils/dateUtility';
import {
  isSupportedImageFile,
  getSupportedFormatsString,
  SUPPORTED_IMAGE_EXTENSIONS,
  SUPPORTED_IMAGE_MIME_TYPES
} from '../../../../utils/supportedImages';
import * as PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PhotoPickerModal from '../../../Upload/PhotoPicker/PhotoPickerModal';
import { importStockPhoto } from '../../../../services/photo/photo';
import { formatStockPhotoTitle } from '../../../../services/photo/stockPhotoTitle';
import { SERVICE_STOCK_PHOTO_TYPE } from '../../../../services/photo/serviceStockPhoto';
import ServiceImageList from './ServiceImageList';

const RenderField = ({
  field,
  onChange,
  onError,
  formData,
  setFormFieldRef,
  disabled,
  isLibrary = false,
  showCustomOptions = false,
  dayDate,
  expandedSections,
  onAccordionChange,
  serviceId,
  tripId,
  destinationTerm = '',
  tripTitle = '',
  onPhotoImportStateChange
}) => {
  const {
    title,
    isrequired,
    description,
    servicefieldtype,
    servicefieldoption,
    servicefieldconfig,
    servicefieldid: id,
    key: fieldKey
  } = field;
  const key = generateServiceTypeFieldKey(field);
  const fieldId = generateServiceTypeFieldId(field);
  const label = `${title}${isrequired ? '*' : ''}`;
  const error = formData[id]?.error || '';
  const { t } = useTranslation(['common', 'trip']);
  const { enableStockPhotoPicker = false } = useFlags();
  const effectiveImageSize = enableStockPhotoPicker
    ? STOCK_PHOTO_MAX_IMAGE_SIZE
    : maxImageSize;
  const fieldTypeKey = servicefieldtype?.key;
  const fieldServiceValueIdName = isLibrary
    ? 'itineraryservicevalueid'
    : 'tripdetaileddayservicevalueid';
  const fieldServiceValueFileIdName = isLibrary
    ? 'itineraryservicevaluefileid'
    : 'tripdetaileddayservicevaluefileid';
  const showDatePlaceholder =
    !isLibrary &&
    fieldTypeKey === 'date' &&
    (fieldKey === 'CHECKINDATE' || fieldKey === 'CHECKOUTDATE') &&
    !dayDate;
  const [isGenerating, setIsGenerating] = useState(false);
  const [photoPickerOpen, setPhotoPickerOpen] = useState(false);
  const [isImportingPhotos, setIsImportingPhotos] = useState(false);
  const imageOptions =
    formData[id]?.options?.filter((option) => option?.value || option?.file) ??
    [];

  const handleChange = (event) => {
    const { value } = event.target;
    if (
      servicefieldtype?.key === 'number' &&
      (Number.isNaN(value) || value < 0)
    ) {
      return;
    }
    onChange(formData[id], event.target.value);
  };

  const handleCustomChange = (value, isFromAI = false) => {
    try {
      onChange(formData[id], value);

      if (isFromAI) {
        setTimeout(() => {
          setIsGenerating(false);
        }, 500);
      }
    } catch (error) {
      setIsGenerating(false);
    }
  };

  const handleCheckboxChange = (fieldId, optionId, updatedOptions) => {
    onChange(formData[id], updatedOptions);
  };

  const { maxcharcount } = servicefieldconfig || {};

  const getRemainingCharsHint = (value = '') => {
    if (maxcharcount) {
      return maxcharcount
        ? `${value?.trim().length ?? 0}/${maxcharcount} ${t('charactersRemaing')}`
        : '';
    }
    return '';
  };

  const isNewFile = (options = [], fileName = '') => {
    return (
      options?.filter((option) => option?.value === fileName)?.length === 0
    );
  };

  const getFieldFiles = (options = []) => {
    return (
      options
        ?.filter((option) => !!option?.file)
        ?.map((option) => option?.file) ?? []
    );
  };

  const getFileOptions = (options = [], files = [], presignType = '') => {
    return files?.map((file, index) => {
      const foundOption = options.find((option) => option.value === file.name);
      const servicefieldoptionid = foundOption?.servicefieldoptionid ?? null;
      const tripdetaileddayservicevalueid =
        foundOption?.tripdetaileddayservicevalueid ?? null;
      const itineraryservicevalueid =
        foundOption?.itineraryservicevalueid ?? null;
      const fieldServiceValueIdValue = isLibrary
        ? itineraryservicevalueid
        : tripdetaileddayservicevalueid;

      return {
        ...foundOption,
        optionId: servicefieldoptionid ?? index + 1,
        sequence: index + 1,
        servicefieldoptionid: servicefieldoptionid,
        [fieldServiceValueIdName]: fieldServiceValueIdValue,
        value: file.name,
        file,
        path: isLibrary
          ? pathReference.LIBRARY
          : pathReference.DETAILED_DAY_SERVICE,
        type: file?.type?.split('/')?.pop(),
        presignType,
        isNew: isNewFile(options, file?.name),
        stockImported: foundOption?.stockImported || false
      };
    });
  };

  const generateFilesData = (files = [], filesData = [], type = '') => {
    const names = files?.map((file) => file?.name);

    const searchNames = names.filter(
      (name) => !filesData.some((item) => item.name === name)
    );

    const missingFiles = files.filter((item) =>
      searchNames?.includes(item.name)
    );

    return [
      ...filesData,
      ...(missingFiles?.map((item) => {
        const tripdetaileddayservicevalueid =
          item?.tripdetaileddayservicevalueid ?? null;
        const itineraryservicevalueid = item?.itineraryservicevalueid ?? null;
        const fieldServiceValueIdValue = isLibrary
          ? itineraryservicevalueid
          : tripdetaileddayservicevalueid;
        const tripdetaileddayservicevaluefileid =
          item?.tripdetaileddayservicevaluefileid ?? null;
        const itineraryservicevaluefileid =
          item?.itineraryservicevaluefileid ?? null;
        const fieldServiceValueFileIdValue = isLibrary
          ? itineraryservicevaluefileid
          : tripdetaileddayservicevaluefileid;

        return {
          [fieldServiceValueIdName]: fieldServiceValueIdValue,
          [fieldServiceValueFileIdName]: fieldServiceValueFileIdValue,
          originalname: item?.name,
          name: item?.name,
          type,
          extension: item?.type?.split('/')?.pop(),
          size: item?.size ?? 0,
          isNew: true
        };
      }) ?? [])
    ];
  };

  const handleImagesSelected = (files = [], data = {}) => {
    // Validate image formats for 'add' action
    if (data.action === 'add') {
      const unsupportedFiles = files.filter(
        (file) => !isSupportedImageFile(file)
      );
      if (unsupportedFiles.length > 0) {
        const errorMessage = t('imageFormatNotSupported', {
          formats: getSupportedFormatsString()
        });
        onError(id, errorMessage);
        return false;
      }
    }

    let filesData = formData[id]?.files ?? [];
    if (enableStockPhotoPicker && data.action === 'add') {
      const existingOptions = imageOptions;
      const newFiles = files.filter(
        (file) => !existingOptions.some((option) => option.file === file)
      );
      const newOptions = getFileOptions([], newFiles, fileType.IMAGE).map(
        (option, index) => ({
          ...option,
          optionId: existingOptions.length + index + 1,
          sequence: existingOptions.length + index + 1
        })
      );
      onChange(formData[id], [...existingOptions, ...newOptions], {
        files: generateFilesData(newFiles, filesData, 'image')
      });
      return true;
    }
    const value = getFileOptions(formData[id]?.options, files, fileType?.IMAGE);

    if (data.action === 'remove') {
      filesData = formData[id]?.files?.filter(
        (file) => file?.name !== data?.file?.name
      );
    }

    if (data.action === 'add') {
      filesData = generateFilesData(files, filesData, 'image');
    }

    onChange(formData[id], value, { files: filesData });
    return true;
  };

  const confirmStockPhotos = async (photos) => {
    const currentOptions = imageOptions;
    const remainingSlots = maxImages - currentOptions.length;
    if ((!isLibrary && !tripId) || photos.length > remainingSlots)
      throw new Error('Image limit exceeded');

    setIsImportingPhotos(true);
    onPhotoImportStateChange?.(id, true);
    try {
      const newOptions = [];
      const newFiles = [];
      for (const photo of photos) {
        const stockTitle = photo.title ?? formatStockPhotoTitle(photo.altText);
        const data = await importStockPhoto({
          provider: photo.provider,
          providerPhotoId: photo.providerPhotoId,
          pathReference: isLibrary
            ? pathReference.LIBRARY
            : pathReference.DETAILED_DAY_SERVICE,
          ...(!isLibrary && { tripId })
        });
        if (!data?.publicUrl || !data?.fileName)
          throw new Error('Missing imported image');
        const file = {
          name: data.fileName,
          type: data.contentType || 'image/jpeg',
          size: data.size || 0,
          previewUrl: data.publicUrl
        };
        newOptions.push({
          optionId: currentOptions.length + newOptions.length + 1,
          sequence: currentOptions.length + newOptions.length + 1,
          servicefieldoptionid: null,
          [fieldServiceValueIdName]: null,
          value: data.fileName,
          file,
          url: data.publicUrl,
          path: isLibrary
            ? pathReference.LIBRARY
            : pathReference.DETAILED_DAY_SERVICE,
          type: file.type.split('/').pop(),
          presignType: fileType.IMAGE,
          isNew: false,
          stockImported: true,
          stockTitle
        });
        newFiles.push({
          [fieldServiceValueIdName]: null,
          [fieldServiceValueFileIdName]: null,
          originalname: stockTitle,
          name: data.fileName,
          type: SERVICE_STOCK_PHOTO_TYPE,
          extension: file.type.split('/').pop(),
          size: file.size,
          isNew: true
        });
      }
      onChange(formData[id], [...currentOptions, ...newOptions], {
        files: [...(formData[id]?.files ?? []), ...newFiles]
      });
      setPhotoPickerOpen(false);
    } finally {
      setIsImportingPhotos(false);
      onPhotoImportStateChange?.(id, false);
    }
  };

  const handleStockTitleChange = (fileName, stockTitle) => {
    onChange(
      formData[id],
      formData[id].options.map((option) =>
        option.value === fileName ? { ...option, stockTitle } : option
      ),
      {
        files: formData[id].files.map((file) =>
          file.name === fileName ? { ...file, originalname: stockTitle } : file
        )
      }
    );
  };

  const handleFilesSelected = async (files = [], data = {}) => {
    let filesData = formData[id]?.files ?? [];
    const value = getFileOptions(formData[id]?.options, files, fileType?.FILE);

    if (data.action === 'remove') {
      filesData = formData[id]?.files?.filter(
        (file) => file?.name !== data?.file?.name
      );
    }
    if (data.action === 'add') {
      filesData = generateFilesData(files, filesData, 'file');
    }

    onChange(formData[id], value, { files: filesData });
  };

  switch (servicefieldtype?.key) {
    case 'textbox':
    case 'number':
      return (
        <Box style={{ position: 'relative' }} ref={setFormFieldRef(fieldId)}>
          <XGInput
            name={fieldId}
            id={fieldId}
            key={key}
            data-testid={fieldId}
            label={label}
            placeholder={description}
            type={servicefieldtype.key}
            onChange={handleChange}
            value={getValueFromServiceField(formData[id]) ?? ''}
            inputProps={{
              maxLength: maxcharcount ?? null,
              min: servicefieldtype?.key === 'number' ? 0 : null
            }}
            error={error !== ''}
            hint={formData[id]?.error}
            disabled={disabled}
          />
          {maxcharcount && (
            <span className='title-length-hint length-hint text-sm-medium'>
              {getRemainingCharsHint(formData[id]?.options[0]?.value)}
            </span>
          )}
        </Box>
      );
    case 'phone':
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <Typography
            fontSize={14}
            fontWeight={500}
            fontFamily={'Inter Variable'}
            className='xg-input-label'
          >
            {label}
          </Typography>
          <MuiTelInput
            name={fieldId}
            id={fieldId}
            key={key}
            defaultCountry='US'
            disabled={disabled}
            inputProps={{
              autoComplete: 'off',
              inputMode: 'numeric',
              pattern: '[0-9]*'
            }}
            onChange={(value) => {
              handleCustomChange(value);
            }}
            value={getValueFromServiceField(formData[id])}
          />
          {error !== '' && (
            <FormHelperText className='input-form-helper-text--error'>
              {formData[id]?.error}
            </FormHelperText>
          )}
        </Box>
      );
    case 'url':
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <XGInput
            id={fieldId}
            name={fieldId}
            key={key}
            data-testid={fieldId}
            label={label}
            placeholder={description}
            type={servicefieldtype.key}
            pattern='https?://.*'
            onChange={handleChange}
            value={getValueFromServiceField(formData[id]) ?? ''}
            inputProps={{
              maxLength: maxcharcount ?? null
            }}
            error={error != ''}
            hint={formData[id]?.error}
            disabled={disabled}
          />
        </Box>
      );
    case 'date':
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <XGDatePicker
            id={fieldId}
            name={fieldId}
            key={key}
            data-testid={fieldId}
            label={label}
            type={servicefieldtype.key}
            format={`${t('common:dateFormat')}`}
            value={getValueFromServiceField(formData[id])}
            onChange={(selectedDate) => {
              // Have to only push the date if the year is after 1900 - XGE-1803
              //  Dates and times before 1850 have a weird offset of (for example) 0456 instead of 0500
              //  Since onChange triggers on each character typed, it goes through years 1, 19, 198, and 1986 when typing "1986".
              //  We don't want to handle the change until the year is one that has normal offset.
              if (selectedDate.getFullYear() > 1900) {
                const utcDate = convertInputDate(selectedDate);
                handleCustomChange(utcDate);
              }
            }}
            error={error != ''}
            helperText={formData[id]?.error}
            disabled={disabled}
            slotProps={{
              textField: {
                ...(showDatePlaceholder && {
                  placeholder: t('trip:setTripDates')
                })
              }
            }}
          />
        </Box>
      );
    case 'time': {
      // Convert ISO string to Date for time picker, or null if no value
      const timeValue = getValueFromServiceField(formData[id]);
      const timeAsDate = timeValue ? utcStringToLocalDate(timeValue) : null;

      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <XGTimePicker
            id={fieldId}
            name={fieldId}
            key={`${key}-${serviceId}`}
            data-testid={fieldId}
            label={label}
            placeholder={description}
            type={servicefieldtype.key}
            format={'HH:mm'}
            ampm={false}
            onChange={(selectedTime) => {
              const utcDate = utcTimeISO(selectedTime);
              return handleCustomChange(utcDate);
            }}
            value={timeAsDate}
            error={error != ''}
            hint={formData[id]?.error}
            disabled={disabled}
          />
        </Box>
      );
    }
    case 'textarea':
      if (field?.key === 'DESCRIPTION') {
        return (
          <Box style={{ marginTop: '16px' }}>
            <Editor
              label={label}
              content={getValueFromServiceField(formData[id]) ?? ''}
              placeholder={description}
              editable={true}
              isPreviewing={false}
              id={`editor-tab-${fieldId}`}
              setMarkdown={(value) => handleCustomChange(value)}
              setDescription={() => {}}
              isEditorDisabled={isGenerating || disabled}
              isEditorGenerating={isGenerating}
              refreshOnChange={isGenerating}
              generatePrompt={
                <div>
                  <AIGenerateButton
                    id='ai-generate-trip-description-button'
                    setMarkdown={(value) => handleCustomChange(value, true)}
                    setTripDescription={() => {}}
                    editorContent={getValueFromServiceField(formData[id]) ?? ''}
                    getAIDescription={getTripDescription}
                    setExtenalIsGenerating={setIsGenerating}
                    disableGenerate={true}
                  />
                </div>
              }
            />
          </Box>
        );
      } else if (field?.key === 'INTERNALNOTE') {
        return (
          <Accordion
            className={`${!showCustomOptions ? 'service-form-accordion' : ''} `}
            sx={{ margin: '0px!important' }}
            disableGutters
            elevation={0}
            expanded={expandedSections?.internalNotes || false}
            onChange={onAccordionChange('internalNotes')}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel-content'
              id='panel-header'
              style={{ padding: '0px' }}
              sx={
                showCustomOptions
                  ? {
                      '& .MuiAccordionSummary-content': {
                        flexGrow: 0,
                        margin: 0
                      },
                      '& .MuiAccordionSummary-expandIconWrapper': {
                        marginLeft: '8px',
                        marginRight: 0
                      },
                      justifyContent: 'flex-start'
                    }
                  : {}
              }
            >
              <Typography
                component='label'
                className='xg-input-label accordion-label '
              >
                {t('trip:internalNotes')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: '0px' }}>
              <Box ref={setFormFieldRef(fieldId)}>
                <Editor
                  content={getValueFromServiceField(formData[id]) ?? ''}
                  placeholder={t('trip:enterInternalNotes')}
                  editable={true}
                  isPreviewing={false}
                  id={`editor-tab-${fieldId}`}
                  setMarkdown={(value) => handleCustomChange(value)}
                  setDescription={() => {}}
                  isEditorDisabled={isGenerating || disabled}
                  isEditorGenerating={isGenerating}
                  refreshOnChange={isGenerating}
                  generatePrompt={null}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      } else {
        return (
          <Box ref={setFormFieldRef(fieldId)}>
            <XGTextarea
              id={fieldId}
              name={fieldId}
              key={key}
              data-testid={fieldId}
              label={label}
              placeholder={description}
              type={servicefieldtype.key}
              onChange={handleChange}
              value={getValueFromServiceField(formData[id]) ?? ''}
              inputProps={{
                maxLength: maxcharcount ?? null
              }}
              error={error !== ''}
              disabled={disabled}
              minRows={3}
            />
            {error !== '' && (
              <FormHelperText className='input-form-helper-text--error'>
                {formData[id]?.error}
              </FormHelperText>
            )}
          </Box>
        );
      }

    case 'select':
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <XGSelect
            id={fieldId}
            name={fieldId}
            key={key}
            data-testid={fieldId}
            label={label}
            placeholder={description}
            type={servicefieldtype.key}
            options={servicefieldoption}
            onChange={handleChange}
            value={getValueFromServiceField(formData[id])}
            error={error != ''}
            helperText={formData[id]?.error}
            disabled={disabled}
          />
        </Box>
      );
    case 'checkbox':
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <CheckBoxGroup
            id={fieldId}
            key={key}
            groupKey={key}
            data-testid={fieldId}
            description={description}
            options={generateCheckBoxOptions(servicefieldoption ?? [])}
            selectedOptions={generateCheckBoxOptions(
              formData[id]?.options || []
            )}
            handleOnChange={handleCheckboxChange}
            fieldId={id}
            label={label}
            error={formData[id]?.error}
            disabled={disabled}
          />
        </Box>
      );
    case 'file':
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <XGAttachments
            id={fieldId}
            name={fieldId}
            key={key}
            data-testid={fieldId}
            label={label}
            placeholder={title}
            type={servicefieldtype.key}
            maxFileSize={maxFileSize}
            onChange={handleChange}
            onError={(error) => onError(id, error)}
            error={error}
            onFilesSelected={handleFilesSelected}
            files={getFieldFiles(formData[id]?.options)}
            displayAddButton={true}
            disabled={disabled}
            maxFiles={maxAttachments}
            alignment='right'
            hint={t('maxFileSize', { maxFileSize: bytesToMiB(maxFileSize) })}
          />
        </Box>
      );
    case 'image':
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <Box
            onClickCapture={(event) => {
              if (
                enableStockPhotoPicker &&
                event.target.closest('#xg-images-add-images-button')
              ) {
                event.preventDefault();
                event.stopPropagation();
                if (imageOptions.length < maxImages) {
                  setPhotoPickerOpen(true);
                }
              }
            }}
          >
            <XGImages
              key={enableStockPhotoPicker ? 'stock' : 'legacy'}
              id={fieldId}
              name={fieldId}
              data-testid={fieldId}
              label={label}
              placeholder={title}
              type={servicefieldtype.key}
              maxFileSize={effectiveImageSize}
              onError={(error) => onError(id, error)}
              error={error}
              onImagesSelected={handleImagesSelected}
              maxFiles={
                imageOptions.length >= maxImages
                  ? getFieldFiles(formData[id]?.options).length
                  : maxImages
              }
              files={
                enableStockPhotoPicker
                  ? []
                  : getFieldFiles(formData[id]?.options)
              }
              displayAddButton={true}
              disabled={
                disabled ||
                isImportingPhotos ||
                (enableStockPhotoPicker && imageOptions.length >= maxImages)
              }
              alignment='left'
              accept={
                enableStockPhotoPicker ? SUPPORTED_IMAGE_EXTENSIONS : undefined
              }
              allowedFileTypes={
                enableStockPhotoPicker ? SUPPORTED_IMAGE_MIME_TYPES : undefined
              }
              typeErrorMessage={
                enableStockPhotoPicker
                  ? t('common:imageFormatNotSupported', {
                      formats: getSupportedFormatsString()
                    })
                  : undefined
              }
              hint={t('maxImageSize', {
                maxImageSize: bytesToMiB(effectiveImageSize)
              })}
            />
          </Box>
          {enableStockPhotoPicker && (
            <ServiceImageList
              options={imageOptions}
              disabled={disabled || isImportingPhotos}
              onTitleChange={handleStockTitleChange}
              onRemove={(option) =>
                onChange(
                  formData[id],
                  formData[id].options.filter(
                    (item) => item.value !== option.value
                  ),
                  {
                    files: (formData[id].files ?? []).filter(
                      (file) => file.name !== option.value
                    )
                  }
                )
              }
            />
          )}
          {enableStockPhotoPicker && (isLibrary || !!tripId) && (
            <PhotoPickerModal
              open={photoPickerOpen}
              onClose={() => setPhotoPickerOpen(false)}
              onConfirm={confirmStockPhotos}
              destinationTerm={isLibrary ? '' : destinationTerm}
              tripTitle={isLibrary ? '' : tripTitle}
              multiple
              remainingSlots={Math.max(0, maxImages - imageOptions.length)}
              onUploadConfirm={async (files) => {
                const result = handleImagesSelected(
                  [...getFieldFiles(formData[id]?.options), ...files],
                  { action: 'add' }
                );
                if (result) setPhotoPickerOpen(false);
                return result;
              }}
            />
          )}
        </Box>
      );
    default:
      return (
        <Box ref={setFormFieldRef(fieldId)}>
          <XGInput
            id={fieldId}
            name={fieldId}
            key={key}
            data-testid={fieldId}
            label={label}
            placeholder={description}
            onChange={handleChange}
            value={getValueFromServiceField(formData[id]) ?? ''}
            inputProps={{
              maxLength: maxcharcount ?? null
            }}
            error={error !== ''}
            hint={formData[id]?.error}
            disabled={disabled}
          />
        </Box>
      );
  }
};

RenderField.propTypes = {
  field: PropTypes.object,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  formData: PropTypes.object,
  setFormFieldRef: PropTypes.func,
  disabled: PropTypes.bool,
  isLibrary: PropTypes.bool,
  showCustomOptions: PropTypes.bool,
  dayDate: PropTypes.any,
  expandedSections: PropTypes.any,
  onAccordionChange: PropTypes.func,
  serviceId: PropTypes.number,
  tripId: PropTypes.number,
  destinationTerm: PropTypes.string,
  tripTitle: PropTypes.string,
  onPhotoImportStateChange: PropTypes.func
};

export default RenderField;
